import script from "./ResetPassView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResetPassView.vue?vue&type=script&setup=true&lang=ts"

import "./ResetPassView.vue?vue&type=style&index=0&id=059e4797&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-059e4797"]])

export default __exports__